module.exports = __webpack_public_path__ + "img/battery_charging_80.debb8e05.svg";